import { frontendURL } from '../../../../helper/URLHelper';

const SettingsContent = () => import('../Wrapper.vue');
const FinopsDashboard = () => import('./FinopsDashboard.vue');
const FinopsTypebotNavigation = () => import('./FinopsTypebotNavigation.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/finops'),
      component: SettingsContent,
      props: {
        headerTitle: 'FINOPS.HEADER',
        icon: 'building-bank',
        keepAlive: false,
      },
      children: [
        {
          path: '',
          redirect: 'dashboard',
        },
        {
          path: 'dashboard',
          name: 'finops_dashboard',
          roles: ['administrator', 'master'],
          component: FinopsDashboard,
        },
        {
          path: 'typebot',
          name: 'finops_typebot_navigation',
          roles: ['administrator', 'master'],
          component: FinopsTypebotNavigation,
        },
      ],
    },
  ],
};
